// assets
import {
  IconBoxMultiple,
  IconDevices2,
  IconUsersGroup,
  IconUser,
} from '@tabler/icons-react';

// constant
const icons = {
  IconBoxMultiple,
  IconDevices2,
  IconUsersGroup,
  IconUser,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
  id: 'pages',
  title: 'Pages',
  type: 'group',
  access: ['super_admin'],
  children: [
    {
      id: 'quotations',
      title: 'Quotations',
      type: 'collapse',
      color: '#2F0F5D',
      icon: icons.IconBoxMultiple,
      access: ['super_admin'],
      children: [
        {
          id: 'all-quotations',
          title: 'All Quotations',
          type: 'item',
          url: '/pages/quotations/all-quotations',
          access: ['super_admin'],
        },
        {
          id: 'new-quotations',
          title: 'New Quotations',
          type: 'item',
          url: '/pages/quotations/new-quotations',
          access: ['super_admin'],
        },
        {
          id: 'sent-to-client',
          title: 'Sent To Client',
          type: 'item',
          url: '/pages/quotations/sent-to-client',
          access: ['super_admin'],
        },
        {
          id: 'accepted',
          title: 'Accepted',
          type: 'item',
          url: '/pages/quotations/accepted',
          access: ['super_admin'],
        },
        {
          id: 'declined',
          title: 'Declined',
          type: 'item',
          url: '/pages/quotations/declined',
          access: ['super_admin'],
        },
        {
          id: 'analyze-declined',
          title: 'Analyze Declined',
          type: 'item',
          url: '/pages/quotations/analyze-declined',
          access: ['super_admin'],
        },
      ],
    },
    {
      id: 'product-management',
      title: 'Product Management',
      type: 'collapse',
      color: '#2F0F5D',
      icon: icons.IconDevices2,
      access: ['super_admin'],
      children: [
        {
          id: 'product-list',
          title: 'Product List',
          type: 'item',
          url: '/pages/product-management/product-list',
          access: ['super_admin'],
        },
        {
          id: 'discontinued-products',
          title: 'Discontinued Products',
          type: 'item',
          url: '/pages/product-management/discontinued-products',
          access: ['super_admin'],
        },
        {
          id: 'uom',
          title: 'Unit of Measurement',
          type: 'item',
          url: '/pages/product-management/uom',
          access: ['super_admin'],
        },
      ],
    },
    {
      id: 'client-management',
      title: 'Client Management',
      type: 'collapse',
      color: '#2F0F5D',
      icon: icons.IconUsersGroup,
      access: ['super_admin'],
      children: [
        {
          id: 'client-list',
          title: 'Client List',
          type: 'item',
          url: '/pages/client-management/client-list',
          access: ['super_admin'],
        },
        {
          id: 'inactivated-client',
          title: 'Inactivated Clients',
          type: 'item',
          url: '/pages/client-management/inactivated-clients',
          access: ['super_admin'],
        },
      ],
    },
    {
      id: 'profile',
      title: 'Profile',
      type: 'item',
      color: '#2F0F5D',
      icon: icons.IconUser,
      access: ['super_admin', 'admin', 'user'],
      url: '/pages/profile',
    },
  ],
};

export default pages;
